module.exports = __webpack_public_path__ + "static/media/icono-descarga.4376072f.svg";